function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { values } from 'ramda';
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_ADDRESSES_CONSTANTS = {
  BEGIN: 'RETRIEVE_ADDRESSES_BEGIN',
  SUCCESS: 'RETRIEVE_ADDRESSES_SUCCESS',
  FAILURE: 'RETRIEVE_ADDRESSES_FAILURE'
};
var retrieveCustomerAddressesPromise = function retrieveCustomerAddressesPromise(dispatch, customerId, includeRemoved) {
  return ThunkHelper(dispatch, values(RETRIEVE_ADDRESSES_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveAddresses',
    data: {
      IncludeRemoved: includeRemoved
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveCustomerAddresses = function retrieveCustomerAddresses(customerId, includeRemoved) {
  return function (dispatch) {
    return retrieveCustomerAddressesPromise(dispatch, customerId, includeRemoved);
  };
};
export var REMOVE_ADDRESS = {
  BEGIN: 'REMOVE_ADDRESS_BEGIN',
  SUCCESS: 'REMOVE_ADDRESS_SUCCESS',
  FAILURE: 'REMOVE_ADDRESS_FAILURE'
};
var removeCustomerAddressPromise = function removeCustomerAddressPromise(dispatch, customerId, addressId) {
  return ThunkHelper(dispatch, values(REMOVE_ADDRESS), {
    method: 'post',
    url: 'SubscriberManagement/RemoveAddress',
    data: {
      Id: addressId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeCustomerAddress = function removeCustomerAddress(customerId, addressId) {
  return function (dispatch) {
    return removeCustomerAddressPromise(dispatch, customerId, addressId);
  };
};
export var CREATE_ADDRESS_CONSTANTS = {
  BEGIN: 'CREATE_ADDRESS_BEGIN',
  SUCCESS: 'CREATE_ADDRESS_SUCCESS',
  FAILURE: 'CREATE_ADDRESS_FAILURE'
};
var createAddressPromise = function createAddressPromise(dispatch, customerId, address, textScrubberOverride, preventOverrideFlag) {
  return ThunkHelper(dispatch, values(CREATE_ADDRESS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/CreateAddress',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Address: prepareAddress(address, preventOverrideFlag),
      TextScrubberOverride: textScrubberOverride
    }
  });
};
export var createAddress = function createAddress(customerId, address, textScrubberOverride, preventOverrideFlag) {
  return function (dispatch) {
    return createAddressPromise(dispatch, customerId, address, textScrubberOverride, preventOverrideFlag);
  };
};
export var UPDATE_ADDRESS_CONSTANTS = {
  BEGIN: 'UPDATE_ADDRESS_BEGIN',
  SUCCESS: 'UPDATE_ADDRESS_SUCCESS',
  FAILURE: 'UPDATE_ADDRESS_FAILURE'
};
var updateAddressPromise = function updateAddressPromise(dispatch, customerId, address, textScrubberOverride, preventOverrideFlag) {
  return ThunkHelper(dispatch, values(UPDATE_ADDRESS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/UpdateAddress',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Address: prepareAddress(address, preventOverrideFlag),
      TextScrubberOverride: textScrubberOverride
    }
  });
};
export var updateAddress = function updateAddress(customerId, address, textScrubberOverride, preventOverrideFlag) {
  return function (dispatch) {
    return updateAddressPromise(dispatch, customerId, address, textScrubberOverride, preventOverrideFlag);
  };
};
export var SET_ADDRESS_DATA = 'SET_ADDRESS_DATA';
export var setAddressData = function setAddressData(address, textScrubberOverride) {
  return {
    type: SET_ADDRESS_DATA,
    payload: {
      address: address,
      textScrubberOverride: textScrubberOverride
    }
  };
};
export var UPDATE_OVERRIDE_FLAG = 'UPDATE_OVERRIDE_FLAG';
export var updateOverrideFlag = function updateOverrideFlag(overrideFlag) {
  return {
    type: UPDATE_OVERRIDE_FLAG,
    payload: overrideFlag
  };
};
export var UPDATE_FORM_ADDRESS = 'UPDATE_FORM_ADDRESS';
export var updateFormAddress = function updateFormAddress(payload) {
  return {
    type: UPDATE_FORM_ADDRESS,
    payload: payload
  };
};

// prepareAddress encapsulates discrepencies w/ the CSG Ascendon Web Services
// API (service layer) and the presentational layer
export var prepareAddress = function prepareAddress(address, preventOverrideFlag) {
  // tie the Name property to the AddressLine1 property
  var proventOverrideObj = {};
  if (preventOverrideFlag) {
    Object.assign(proventOverrideObj, {
      PreventValidationOverride: preventOverrideFlag
    });
  }
  return Object.assign({}, address, {
    Name: address.Name || address.LineOne
  }, proventOverrideObj);
};
export var SET_INCLUDED_REMOVED_FILTER = 'SET_ADDRESSES_INCLUDED_REMOVED_FILTER';
export var setIncludedRemovedFilter = function setIncludedRemovedFilter(includedFilter) {
  return {
    type: SET_INCLUDED_REMOVED_FILTER,
    payload: includedFilter
  };
};
export var EMPTY_ADDRESSES_LIST = 'EMPTY_ADDRESSES_LIST';
export var emptyAddressesList = function emptyAddressesList() {
  return {
    type: EMPTY_ADDRESSES_LIST
  };
};
export var REMOVE_ADDRESSES_FILTER = 'REMOVE_ADDRESSES_FILTER';
export var removeAddressesFilter = function removeAddressesFilter() {
  return {
    type: REMOVE_ADDRESSES_FILTER
  };
};
export var SET_SELECTED_ITEM_ID = 'SET_SELECTED_ITEM_ID';
export var setSelectedItemId = function setSelectedItemId(includedId) {
  return {
    type: SET_SELECTED_ITEM_ID,
    payload: includedId
  };
};